// extracted by mini-css-extract-plugin
export default {"wraper":"Menu_wraper__FoIOH","menu":"Menu_menu__KNsVS","close":"Menu_close__9lurZ","list":"Menu_list__7yt49"};